import { combineReducers } from "redux"
import authReducer from "reducers/authReducer"
import organizationReducer from "reducers/organizationReducer"
import projectReducer from "reducers/projectReducer"
import promoCodeReducer from "reducers/promoCodeReducer"
import singleReducer from "reducers/singleReducer"
import { firebaseReducer } from "react-redux-firebase"
import { firestoreReducer } from "redux-firestore"

export default combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  authState: authReducer,
  organization: organizationReducer,
  projects: projectReducer,
  promoCode: promoCodeReducer,
  single: singleReducer,
})
